import { connect } from 'react-redux';
import React from 'react';
import * as selectors from 'app/selectors';
import { FIX_LOCATION } from 'app/constants/hint';
import LocationRoleUsersForm from './LocationRoleUsersForm';

function LocationSettingFinanceForm({ updateLocation, users, financeManager }) {
  return (
    <LocationRoleUsersForm
      updateLocation={updateLocation}
      users={users}
      fields={[
        {
          name: 'finance_ids',
          role: 'finance',
          title: '财务人员',
          hint: FIX_LOCATION.finance,
          selectedUsers: financeManager,
          requiredMessage: '请选择至少一位财务人员'
        }
      ]}
    />
  );
}

function mapStateToProps(state, props) {
  const { loc_id } = props;
  return {
    users: selectors.getSpaceUsers(state),
    financeManager: selectors.getTeamRolesOfLocation(state, loc_id, 'finance')
  };
}

export default connect(mapStateToProps)(LocationSettingFinanceForm);
